// Temporary shim (ENG-33462): the AIO criteria components moved to
// incident-rules-v2. Delete this file with the rest of the legacy feature.
export * from '../../../incident-rules-v2/ai-operator-criteria/components/AiOperatorCriteria'
